import React from 'react'
import {renderPopular} from '../../utils'


class MyLectureItem extends React.Component {
    render() {
        const {data} = this.props
        return(
            <div className="my-lecture-item" onClick={() => location.href = `/lecture/${data.id}`}>
                <div className="my-lecture-item__left">
                    <div className="my-lecture-item__left-img background-image" style={{backgroundImage: `url(${data.cover_url})`}}/>
                </div>
                <div className="my-lecture-item__right">
                    <p className="my-lecture-item__title" style={{WebkitBoxOrient: 'vertical'}}>{data.name}</p>
                    <div className="my-lecture-item__bottom">
                        <span className="my-lecture-item__bottom-popular">{renderPopular(data.popular)}人气</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default MyLectureItem


// WEBPACK FOOTER //
// ./src/pages/mywkPage/MyLectureItem.js